import { render, staticRenderFns } from "./dstr-support-invoice.vue?vue&type=template&id=22a37b0a"
import script from "./dstr-support-invoice.vue?vue&type=script&lang=js"
export * from "./dstr-support-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports